import React from 'react';

import cx from 'classnames';
import getColourPropsByColourSchemaAndCampaignColor from 'utils/getColourPropsByColourSchemaAndCampaignColor';

import DynamicHeadingLine from 'components/DynamicHeadingLine/DynamicHeadingLine';
import LinkButtonRow from 'components/LinkButtonRow/LinkButtonRow';
import VerticalTile, {
  VerticalTileProps,
} from 'components/VerticalTile/VerticalTile';
import { ICampaignContent } from 'models/campaignContent';

interface IProps extends VerticalTileProps {
  campaignContent: ICampaignContent;
  colour: string;
}
const StatisticTileCampaignContent: React.FC<IProps> = ({
  campaignContent,
  colour,
  className,
  style = {},
  ...props
}) => {
  const { backgroundColor, btnVariant, headingColor, textColorClass } =
    getColourPropsByColourSchemaAndCampaignColor(
      colour,
      campaignContent.colour_schema?.name,
    );

  return (
    <VerticalTile
      {...props}
      style={{
        ...style,
        backgroundColor: campaignContent.colour_schema
          ? backgroundColor
          : undefined,
      }}
      className={cx(
        'no-shadow w-100 flex-grow-1',
        { 'bg-light-grey': !campaignContent.colour_schema },
        textColorClass,
        className,
      )}
    >
      <h1 data-content="campaign_content_heading" className="text-left">
        {campaignContent.heading}
      </h1>
      <DynamicHeadingLine className="mt-3 mb-4 w-50" colour={headingColor} />
      <h4 data-content="campaign_content_sub_heading" className="text-left">
        {campaignContent.sub_heading}
      </h4>
      <LinkButtonRow
        btnProps={{ variant: btnVariant }}
        links={campaignContent.links || []}
      />
    </VerticalTile>
  );
};

export default StatisticTileCampaignContent;
